module.exports = __webpack_public_path__ + "img/nl.c60ddf8b.svg";